import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface SetFlowDraftNameParams {
 readonly id: string;
 readonly name: string;
}

export interface SetFlowNameDraftResult extends IResult {
}

export class SetFlowDraftNameRequest extends Request<SetFlowDraftNameParams, SetFlowNameDraftResult> {
 constructor(params: SetFlowDraftNameParams) {
   super('setFlowDraftName', params);
 }
}